/**************************************************
 * Nombre:       Seccion_Home
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Home_Portada from "./Componentes/Home_Portada";
import Home_Lineas from "./Componentes/Home_Lineas";
import Home_Varietales from "./Componentes/Home_Varietales";
import Home_Contactos from "./Componentes/Home_Contactos";
import Home_Certfiicados from "./Componentes/Home_Certfiicados";
import {theme} from "../../Tema";
import Home_Caracteristicas from "./Componentes/Home_Caracteristicas";
import Home_Testimonios from "./Componentes/Home_Testimonios";
import {SECCIONES} from "../../Constantes";
import {useEffect} from "react";
import {irArriba} from "../../Utilidades/irArriba";

const Seccion_Home = () => {

    useEffect(() =>{

        irArriba()

    },[])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{backgroundColor: '#202020'}}
        >


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: -15.2}}>
                <Home_Portada/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Home_Lineas/>
            </Grid>

            <Grid
                id={SECCIONES[0]}
                container size={{xs: 12, sm: 12, md: 12}}
                sx={{justifyContent: 'flex-start', mt: 0, borderBottom: 1, borderColor: theme.palette.primary.main,}}>
                <Home_Varietales/>
            </Grid>

            <Grid
                id={SECCIONES[1]}
                container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 16}}>
                <Home_Certfiicados/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 16}}>
                <Home_Caracteristicas/>
            </Grid>

            <Grid
                id={SECCIONES[2]}
                container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Home_Testimonios/>
            </Grid>

            <Grid
                id={'Contactos'}
                container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Home_Contactos/>
            </Grid>


        </Grid>
    )

}
export default Seccion_Home